import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_001.jpg';

page.games = [
  {
    id: 'page001_game0',
    pos: { x: RIGHT, y: 0 },
  },
  {
    id: 'page001_game1',
    pos: { x: RIGHT, y: 0 },
  },
];

export default page;
